export const calcPercent = (a: number, b: number): number => {
  if (!b) return 0
  return a / b
}
